import script from "./refundRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./refundRecords.vue?vue&type=script&setup=true&lang=js"

import "./refundRecords.vue?vue&type=style&index=0&id=3d1dc7dc&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d1dc7dc"]])

export default __exports__